import RailsResource from './rails-resource';

class PersonService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'people',
      ajaxLoader: false
    });
  }

  findBy(query = {}) {
    query = Object.entries(query).map((it) => it.join('=')).join('&')
    return this.call(`${this.url}/${this.resource}.json?${query}`);
  }
}

export default new PersonService();
